import { render, staticRenderFns } from "./cart-confirm.vue?vue&type=template&id=fd52c8de&scoped=true&"
import script from "./cart-confirm.vue?vue&type=script&lang=js&"
export * from "./cart-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd52c8de",
  null
  
)

export default component.exports